import React from 'react';
import {useFormikContext} from 'formik';
import {TextField, Card} from '@mui/material';

export default function DeaccessionEntryThree() {
  const {values, setFieldValue, touched, errors} = useFormikContext();

  const getDisplayValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  return (
    <Card className={'box-shadow'} sx={{p: 4}}>
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Condition'}
        value={getDisplayValue(values?.condition)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Storage Location'}
        value={getDisplayValue(values?.storage_location)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Place of Origin'}
        value={getDisplayValue(values?.place_of_origin)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Additional Information'}
        value={getDisplayValue(values?.other_info)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Exhibition History'}
        value={getDisplayValue(values?.exhibition_history)}
        disabled
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Justification'}
        value={values?.translations?.en?.justification || ''}
        onChange={(e) => setFieldValue('translations.en.justification', e.target.value)}
        required
        error={touched?.translations?.en?.justification && !!errors?.translations?.en?.justification}
        helperText={touched?.translations?.en?.justification && errors?.translations?.en?.justification}
        multiline
        rows={3}
        autoFocus
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
    </Card>
  );
}